/** time formatting library */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Return duration in format HH:mm:ss
 * @param {Number} duration Duration time in seconds (not more than 99:59:59)
 */
export const getDurationTimeline = duration => {
  const parts = getTimeParts(duration);
  return parts.map(n => n.toString().padStart(2, "0")).join(":");
};

/**
 * Return duration in format HH:mm:ss with leading zeroes truncated
 * @param {Number} duration Duration time in seconds (not more than 99:59:59)
 */
export const getTruncatedDurationTimeline = duration => {
  if (duration === 0) {
    return "0";
  }

  const parts = getTimeParts(duration);

  let areZeroesBefore = true;
  let line = "";
  for (const p of parts) {
    if (!areZeroesBefore) {
      line += `:${p.toString().padStart(2, "0")}`;
    } else if (p > 0) {
      line += p.toString();
      areZeroesBefore = false;
    }
  }

  return line;
};

/**
 * Return time string with passed format
 * @param {Number} timestamp UNIX timestamp
 * @param {String} format time format line
 * @param {String} timezone timezone name
 * @returns
 */
export const formatTime = (timestamp, format, timezone = "UTC") => {
  return dayjs(timestamp * 1000)
    .tz(timezone)
    .format(format);
};

/**
 * Parse time with selected timezone
 * @param {String} timestamp time line
 * @param {String} timezone timezone name
 * @returns
 */
export const parseTime = (time, timezone = "UTC") => {
  return new Date(dayjs(time).tz(timezone, true));
};

/**
 * Return time in format DD-DD-YYYY HH:mm:ss
 * @param {Number} timestamp UNIX timestamp
 * @param {String} timezone timezone name
 */
export const getDateAndTimeLine = (timestamp, timezone = "UTC") => {
  return dayjs(timestamp * 1000)
    .tz(timezone)
    .format("DD-MM-YYYY HH:mm:ss");
};

/**
 * Return time in format HH:mm:ss
 * @param {Number} timestamp UNIX timestamp
 * @param {String} timezone timezone name
 */
export const getTimeLine = (timestamp, timezone = "UTC") => {
  return dayjs(timestamp * 1000)
    .tz(timezone)
    .format("HH:mm:ss");
};

/**
 * Return time in format HH:mm:ss.SSS
 * @param {Number} timestamp UNIX timestamp
 * @param {String} timezone timezone name
 */
export const getTimeLineWithMs = (timestamp, timezone = "UTC") => {
  return dayjs(timestamp * 1000)
    .tz(timezone)
    .format("HH:mm:ss.SSS");
};

/**
 * Return time in format for clock HH:mm:ss
 * @param {Number} timestamp UNIX timestamp
 * @param {String} timezone timezone name
 */
export const getTimeLineForWatch = (timestamp, timezone = "UTC") => {
  return dayjs(timestamp * 1000)
    .tz(timezone)
    .format("HH:mm:ss:SSS");
};

/**
 * Format duration preserving milliseconds precision
 * @param {Number} seconds Duration in seconds
 * @returns {String}
 */
export const formatDurationWithMs = seconds => {
  const duration = dayjs()
    .startOf("day")
    .add(seconds, "seconds");

  const format = duration.hour() ? "HH:mm:ss.SSS" : "mm:ss.SSS";
  return duration.format(format);
};

/**
 * Round value to milliseconds precision
 * @param {Number} value Value in seconds
 * @returns {Number}
 */
export const roundToMilliseconds = value => {
  return Math.round(value * 1000) / 1000;
};

/**
 * Compare timestamps allowing millisecond rounding tolerance
 * @param {Number} a
 * @param {Number} b
 * @param {Number} epsilon Allowed difference in seconds
 * @returns {Boolean}
 */
export const areTimesEqual = (a, b, epsilon = 0.0005) => {
  if (!Number.isFinite(a) || !Number.isFinite(b)) {
    return false;
  }

  return Math.abs(a - b) < epsilon;
};

export const getFormatPlayerTime = (timestamp, timezone = "UTC") => {
  return dayjs(timestamp * 1000)
    .tz(timezone)
    .format("HH:mm:ss");
    // .unix();
    //.format()
    // .toString()
    // .toISOString()
    // .toDate()
    // .utc().format()
    // .toDate()
};

/**
 * Get time and return it splitted into hours, minutes, seconds
 * @param {Number} time Time in seconds
 * @returns {Array} return array of three elements [hours, minutes, seconds]
 */
function getTimeParts(time) {
  const h = Math.floor(time / 3600);
  const m = Math.floor((time % 3600) / 60);
  const s = Math.floor(time % 60);

  return [h, m, s];
}

export function mediaSourceTimeToResultTime(sourceTime, ranges) {
  let acc = 0;
  for (const [start, end] of ranges) {
    if (sourceTime < start) return null;
    if (sourceTime <= end) return acc + (sourceTime - start);
    acc += end - start;
  }
  return ranges.length < 1 ? sourceTime : null; // not inside any kept range
}